import { useReducer } from 'react';
import { FREQUENCY } from '../../models/DonationFrequency';
import { AMOUNT_INPUT } from '../../models/DonationAmount';
import { getNumberFromCurrencyString } from './utils/getNumberFromCurrencyString';
const ImpactReducer = (state, action) => {
  switch (action.type) {
    case 'SELECT_PRESET_AMOUNT_BUTTON':
      {
        const {
          donationAmount
        } = action;
        return {
          ...state,
          activeDonationAmountName: donationAmount.name,
          amountNumber: donationAmount.amount
        };
      }
    case 'SELECT_OTHER_AMOUNT_BUTTON':
      {
        if (state.activeDonationAmountName === AMOUNT_INPUT.OTHER) {
          return state;
        }
        const otherAmountNumber = getNumberFromCurrencyString(state.otherAmountDisplayValue, state.currencyCode);
        return {
          ...state,
          activeDonationAmountName: AMOUNT_INPUT.OTHER,
          amountNumber: otherAmountNumber
        };
      }
    case 'SELECT_RECURRING_END_DATE':
      {
        const {
          recurrentEndDate
        } = action;
        return {
          ...state,
          recurringEndDate: recurrentEndDate
        };
      }

    /*
     * One-time and Recurring frequencies can have different configured amounts.
     * If we are changing from one-time to recurring or vice versa, we need to additionally
     * update the amountNumber in state (which is always the single source of truth for amount-to-be-donated), which
     * we choose to be the defaultAmount for the particular frequency type. We also then update the selected preset
     * amount to the default for the frequency type.
     */
    case 'SELECT_DONATION_FREQUENCY':
      {
        const {
          frequency
        } = action;
        const isPreviousFrequencyRecurring = state.frequency !== FREQUENCY.ONE_TIME;
        const isChosenFrequencyRecurring = frequency !== FREQUENCY.ONE_TIME;
        const arePreviousAndChosenFrequenciesOfSameType = isPreviousFrequencyRecurring === isChosenFrequencyRecurring;
        if (arePreviousAndChosenFrequenciesOfSameType) {
          return {
            ...state,
            frequency,
            recurringEndDate: ''
          };
        }
        const defaultAmount = isChosenFrequencyRecurring ? state.defaultRecurringAmount : state.defaultOneTimeAmount;
        return {
          ...state,
          frequency,
          amountNumber: defaultAmount.amount,
          otherAmountDisplayValue: String(defaultAmount.amount),
          activeDonationAmountName: defaultAmount.name,
          recurringEndDate: ''
        };
      }
    case 'SELECT_PROGRAM_DESIGNATION':
      {
        const {
          programDesignation
        } = action;
        return {
          ...state,
          programDesignation
        };
      }
    case 'SET_OTHER_AMOUNT_DISPLAY_VALUE':
      {
        const {
          value
        } = action;
        const valueAsNumber = getNumberFromCurrencyString(value, state.currencyCode);
        return {
          ...state,
          otherAmountDisplayValue: value,
          amountNumber: valueAsNumber
        };
      }
    case 'TOUCH_ERRORABLE_INPUT':
      {
        const {
          input
        } = action;
        switch (input) {
          case 'otherAmountInput':
            return state.isOtherAmountInputTouched ? state : {
              ...state,
              isOtherAmountInputTouched: true
            };
          case 'recurringEndDateSelect':
            return state.isRecurringEndDateSelectTouched ? state : {
              ...state,
              isRecurringEndDateSelectTouched: true
            };
          case 'programDesignationSelect':
            return state.isProgramDesignationSelectTouched ? state : {
              ...state,
              isProgramDesignationSelectTouched: true
            };
          case 'callToActionButton':
            return state.isCallToActionButtonTouched ? state : {
              ...state,
              isCallToActionButtonTouched: true
            };
          default:
            return state;
        }
      }
    case 'SET_ENTIRE_BLOCK_STATE':
      {
        return action.newBlockState;
      }
    default:
      return state;
  }
};
export const useImpactBlockReducer = initialState => useReducer(ImpactReducer, initialState);